// Safari 12兼容性检测和polyfills
(function() {
  'use strict';

  // 检测是否支持可选链操作符
  function supportsOptionalChaining() {
    try {
      // 使用安全的检测方式，避免语法错误
      return new Function('try { return {}?.test !== undefined; } catch (e) { return false; }')();
    } catch (e) {
      return false;
    }
  }

  // 检测是否支持空值合并操作符
  function supportsNullishCoalescing() {
    try {
      return new Function('try { return (null ?? "default") === "default"; } catch (e) { return false; }')();
    } catch (e) {
      return false;
    }
  }

  // 检测是否支持ES6模块
  function supportsESModules() {
    try {
      return new Function('import("")').constructor === (async function() {}).constructor;
    } catch (e) {
      return false;
    }
  }

  // 检测是否为Safari 12或更早版本
  function isSafari12OrEarlier() {
    const ua = navigator.userAgent;
    const safariMatch = ua.match(/Version\/(\d+).*Safari/);
    if (safariMatch) {
      return parseInt(safariMatch[1]) <= 12;
    }
    return false;
  }

  // 检测总体兼容性
  function isCompatibleBrowser() {
    return supportsOptionalChaining() && 
           supportsNullishCoalescing() && 
           supportsESModules() && 
           !isSafari12OrEarlier();
  }

  // 为Safari 12添加基础的错误处理
  if (isSafari12OrEarlier()) {
    // 全局错误处理，捕获语法错误
    window.addEventListener('error', function(event) {
      if (event.message && event.message.includes('Unexpected token')) {
        console.error('Syntax error detected (likely due to unsupported ES2020+ features):', event.message);
      }
    });
  }

  // 导出兼容性检测函数供其他模块使用
  if (typeof window !== 'undefined') {
    window.__browserCompatibility = {
      isCompatible: isCompatibleBrowser(),
      supportsOptionalChaining: supportsOptionalChaining(),
      supportsNullishCoalescing: supportsNullishCoalescing(),
      supportsESModules: supportsESModules(),
      isSafari12OrEarlier: isSafari12OrEarlier()
    };
  }
})();